import type { V1ValueType } from '@/generated/hooks/grimoire/models';

const SCALAR_LABELS: Record<string, string> = {
  VALUE_SCALAR_TYPE_TEXT: 'text',
  VALUE_SCALAR_TYPE_NUMBER: 'number',
  VALUE_SCALAR_TYPE_BOOLEAN: 'boolean',
  VALUE_SCALAR_TYPE_DATETIME: 'datetime',
  VALUE_SCALAR_TYPE_DATE: 'date',
  VALUE_SCALAR_TYPE_TIME: 'time',
  VALUE_SCALAR_TYPE_FILE: 'file',
  VALUE_SCALAR_TYPE_TIMEDELTA: 'timedelta',
};

/**
 * Renders a manifest `ValueType` as a short technical label (e.g. "text",
 * "list<text>", "table"). Not translated — these are code-level type names
 * from the automation's SPy signature, not prose.
 */
export function formatValueType(type?: V1ValueType): string {
  if (!type) return '';

  if (type.scalar_type) {
    return SCALAR_LABELS[type.scalar_type] ?? type.scalar_type.toLowerCase();
  }
  if (type.optional_type) {
    return `${formatValueType(type.optional_type.inner)} (optional)`;
  }
  if (type.sensitive_type) {
    return `${formatValueType(type.sensitive_type.inner)} (sensitive)`;
  }
  if (type.list_type) {
    return `list<${formatValueType(type.list_type.inner)}>`;
  }
  if (type.dictionary_type) {
    return type.dictionary_type.is_a || 'dictionary';
  }
  if (type.table_type) {
    return type.table_type.is_a || 'table';
  }
  if (type.opaque_type) {
    return type.opaque_type.is_a || 'object';
  }
  if (type.enum_type) {
    return type.enum_type.is_a || 'enum';
  }
  if (type.union_type) {
    return (type.union_type.inners ?? []).map(formatValueType).join(' | ');
  }
  if (type.generic_dictionary_type) {
    return 'dictionary';
  }
  if (type.none_type) {
    return 'none';
  }
  return 'any';
}
